module.exports = __webpack_public_path__ + "img/construction_icon.fad0e951.svg";